// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__jNqDc","box":"Checkbox_box__tTaJk","label":"Checkbox_label__RXuGv"};